import { useMemo } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import {
  Bonus,
  Documents,
  DocumentHubPage,
  KnowledgeBasePage,
  EmployeePage,
  EmployeesPage,
  Home,
  InvitationPage,
  Login,
  NotFoundPage,
  NotificationsPage,
  RequestPage,
  RequestsPage,
  ProjectCodesPage,
  VacationPage,
  TimesheetPage,
  AssessmentPage,
  ProfilePage,
  PerformanceReviewsPage,
  TimesheetAdminPage,
  PerformanceReviewPage,
  AssistantPage,
  PeoplePage,
  PeopleProfilePage,
} from "@/pages";
import { ROUTES } from "@/shared/constants";
import PrivateRoute from "./private-route";

const APP_MODE = (import.meta.env.VITE_APP ?? "APP") as "APP" | "ASSESSMENT";

const employeeRoutes = {
  element: <PrivateRoute userType="employee" />,
  children: [
    { index: true, element: <Home /> },
    { path: ROUTES.BONUS, element: <Bonus /> },
    { path: ROUTES.DOCUMENTS, element: <Documents /> },
    { path: ROUTES.DOCUMENT_HUB, element: <DocumentHubPage /> },
    { path: ROUTES.KNOWLEDGE_BASE, element: <KnowledgeBasePage /> },
    { path: ROUTES.VACATION, element: <VacationPage /> },
    { path: ROUTES.TIMESHEET, element: <TimesheetPage /> },
    { path: ROUTES.PROFILE, element: <ProfilePage /> },
    { path: ROUTES.ASSISTANT, element: <AssistantPage /> },
    { path: ROUTES.PEOPLE, element: <PeoplePage /> },
    { path: ROUTES.PEOPLE_PROFILE(), element: <PeopleProfilePage /> },
  ],
};

const adminRoutes = {
  element: <PrivateRoute userType="admin" />,
  children: [
    { path: ROUTES.ADMIN, element: <EmployeesPage /> },
    { path: ROUTES.ADMIN_EMPLOYEES(), element: <EmployeePage /> },
    { path: ROUTES.ADMIN_NOTIFICATIONS, element: <NotificationsPage /> },
    { path: ROUTES.ADMIN_REQUESTS, element: <RequestsPage /> },
    { path: ROUTES.ADMIN_REQUESTS_TYPE(), element: <RequestPage /> },
    { path: ROUTES.ADMIN_PROJECT_CODES, element: <ProjectCodesPage /> },
    { path: ROUTES.ADMIN_PERFORMANCE_REVIEWS, element: <PerformanceReviewsPage /> },
    { path: ROUTES.ADMIN_TIMESHEET, element: <TimesheetAdminPage /> },
    { path: ROUTES.ADMIN_PERFORMANCE_REVIEW(), element: <PerformanceReviewPage /> },
  ],
};

const publicRoutes = [
  { path: ROUTES.LOGIN, element: <Login /> },
  { path: ROUTES.INVITATION, element: <InvitationPage /> },
  { path: ROUTES.NOT_FOUND, element: <NotFoundPage /> },
];

const assessmentPrivate = {
  element: <PrivateRoute />,
  children: [{ path: ROUTES.ASSESSMENT, element: <AssessmentPage /> }],
};

export const AppRoutes = () => {
  const routes = useMemo(() => {
    return APP_MODE === "ASSESSMENT"
      ? [{ index: true, element: <Navigate to={ROUTES.ASSESSMENT} replace /> }, ...publicRoutes, assessmentPrivate]
      : [...publicRoutes, assessmentPrivate, employeeRoutes, adminRoutes];
  }, [APP_MODE]);

  return useRoutes(routes);
};
